interface MoengageSDK {
    initialize: (config: Record<string, string | number>) => void;
    add_unique_user_id: (userId: string) => void;
    destroy_session: () => void;
    add_email: (value: string) => void;
    add_mobile: (value: string) => void;
    add_first_name: (value: string) => void;
    add_last_name: (value: string) => void;
    add_user_name: (value: string) => void;
    add_user_attribute: (key: string, value: unknown) => void;
    track_event: (eventName: string, params: Record<string, unknown>) => void;
}

let moengageModulePromise: Promise<MoengageSDK> | null = null;
let moengageInitPromise: Promise<MoengageSDK> | null = null;
const isDevelopment = process.env.NODE_ENV === 'development';

const getMoengage = async () => {
    if (!moengageModulePromise) {
        moengageModulePromise = import('@moengage/web-sdk').then(
            (module) => module.default as unknown as MoengageSDK
        );
    }

    return moengageModulePromise;
};

export const initMoengage = () => {
    if (typeof window === 'undefined') return;

    if (!moengageInitPromise) {
        moengageInitPromise = getMoengage().then((moengage) => {
            moengage.initialize({
                app_id: process.env.NEXT_PUBLIC_MOENGAGE_WORKSPACE_ID as string,
                cluster: process.env.NEXT_PUBLIC_MOENGAGE_DC as string,
                debug_logs: process.env.NODE_ENV === 'development' ? 1 : 0
            });

            if (isDevelopment) {
                console.log('MoEngage initialized');
            }

            return moengage;
        });
    }

    return moengageInitPromise;
};


export const moengageLogin = (userId: string) => {
    if (typeof window === 'undefined') return;

    void (initMoengage() ?? getMoengage()).then((moengage) => {
        moengage.add_unique_user_id(userId);

        if (isDevelopment) {
            console.log('MoEngage Login (Unique ID set):', userId);
        }
    });
};

export const moengageLogout = () => {
    if (typeof window === 'undefined') return;

    void (initMoengage() ?? getMoengage()).then((moengage) => {
        moengage.destroy_session();

        if (isDevelopment) {
            console.log('MoEngage Logout (Session destroyed)');
        }
    });
};

export const moengageUpdateUserAttribute = (key: string, value: unknown) => {
    if (typeof window === 'undefined') return;

    void (initMoengage() ?? getMoengage()).then((moengage) => {
        switch (key) {
            case 'email':
                moengage.add_email(String(value));
                break;
            case 'mobile':
                moengage.add_mobile(String(value));
                break;
            case 'firstName':
                moengage.add_first_name(String(value));
                break;
            case 'lastName':
                moengage.add_last_name(String(value));
                break;
            case 'name':
                moengage.add_user_name(String(value));
                break;
            default:
                moengage.add_user_attribute(key, value);
                break;
        }

        if (isDevelopment) {
            console.log(`MoEngage Attribute Set [${key}]:`, value);
        }
    });
};

export const trackMoEngageEvent = (eventName: string, params?: Record<string, unknown>) => {
    if (typeof window === 'undefined') return;

    void (initMoengage() ?? getMoengage()).then((moengage) => {
        moengage.track_event(eventName, params || {});

        if (isDevelopment) {
            console.log('MoEngage Event Tracked:', eventName, params);
        }
    });
};
